import { defineAction } from '~/prix'
import communityCreateAction from './communityCreate.action.json' with { type: 'json' }
import { communityObject } from '../communityObject'
import { z } from 'zod'

const communityCreateDefinition = defineAction({
  ...communityCreateAction,

  input: communityObject,
  output: z.object({}),
})

export default communityCreateDefinition
